import { createClient } from "@sanity/client";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET;
const apiVersion = process.env.REACT_APP_SANITY_API_VERSION;
const token = process.env.REACT_APP_SANITY_API_READ_TOKEN;

if (!projectId) {
  throw new Error("Missing REACT_APP_SANITY_PROJECT_ID");
}
if (!dataset) {
  throw new Error("Missing REACT_APP_SANITY_DATASET");
}

const baseClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  perspective: "published",
  token
});

type SanityClient = typeof baseClient & {
  fetch<T = any>(query: string, params?: Record<string, unknown>): Promise<T>;
};

export const client = baseClient as SanityClient;

export async function fetchSanity<T = any>(
  query: string,
  params: Record<string, unknown> = {}
): Promise<T> {
  return client.fetch<T>(query, params);
}
